import styled from 'styled-components';

export const FeatureImageWrapper = styled.div`
  grid-column: 3 / span 10;
  grid-row: 2 / 4;
  overflow: hidden;
  position: relative;
  
  h1 {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -40%);
    z-index: 999;
    border: .5px solid #000;
  }
  
  
  @media ${props => props.theme.breakpoints.tablet} {
    grid-column: 2 / span 6;
  }
  
  @media ${props => props.theme.breakpoints.mobile} {
    grid-column: 1 / -1;
  }
`
